class TSCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.cartDrawerTrigger = document.querySelector("#TSCartTrigger");
    this.isLoading = false;

    if (this.cartDrawerTrigger) {
      this.cartDrawerTrigger.addEventListener("click", () => {
        this.open();
      })
    }

    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        const item = e.target.closest("[data-line]");
        const line = item ? item.dataset.line : false;

        switch (e.target.dataset.trigger) {
          case "close":
            this.close();
            break;
          case "delete":
            if (this.isLoading) break;
            this.updateQuanity(line, 0);
          case "quantity":
            if (this.isLoading) break;
            let quantity = parseInt(item.querySelector('input[name="quantity"]').value);

            if (e.target.hasAttribute("data-plus")) {
              quantity += 1;
            } else if (e.target.hasAttribute("data-minus")) {
              quantity -= 1;
            }
            this.updateQuanity(line, quantity);
            break;
          case "upsell-add":
            if (this.isLoading) break;
            const upsellProductItem = e.target.closest("[data-variant]");
            this.addUpsellItem(parseInt(upsellProductItem.dataset.variant));
            break;
        }
      }
    })
  }

  updateQuanity(line, quantity) {
    this.toggleLoading();
    const data = {
      line: `${line}`,
      quantity: `${quantity}`,
      sections: ["header"],
      sections_url: window.location.pathname
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(response => {
      this.renderContent(response.sections)
    })
    .catch((error) => {
      console.error('Error:', error);
    })
    .finally(this.toggleLoading.bind(this));
  }

  addUpsellItem(upsellProduct) {
    this.toggleLoading();
    const sections = ["header"];
    const cartData = {
      items: [
        {
          id: upsellProduct,
          quantity: 1
        }
      ],
      sections: sections,
      sections_url: window.location.pathname
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(cartData),
    })
    .then(response => response.json())
    .then(response => {
      if (!response.items) {
        let error = new Error(response.description);
        throw error;
      } else {
        this.renderContent(response.sections);
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(this.toggleLoading.bind(this));
  }
 
  renderContent(sections) {
    const html = new DOMParser().parseFromString(sections['header'], "text/html");

    const selectors = [
      "#TSCartTrigger",
      "ts-cart .ts-cart__inner"
    ];

    document.querySelector("#TSCartTrigger").classList.toggle("has-blip-visible", html.querySelector("#TSCartTrigger").classList.contains("has-blip-visible"));

    selectors.forEach(selector => {
      if (document.querySelector(selector) && html.querySelector(selector)) {
        document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
      }
    })

    this.open();
  }

  open() {
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }

  toggleLoading() {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading", this.isLoading);
  }
}

customElements.define("ts-cart", TSCartDrawer);